import client from '@/support/Client';
import { Model } from '@/models/Model';
import { isObject } from 'util';
import { UserSubjectStatusEnum } from './UserSubject';
export class Subject extends Model {
    constructor() {
        super(...arguments);
        this.editing = false;
        this.$name = 'Subject';
        this.$endpoint = '/subjects';
        this.$fillable = ['name', 'color', 'parent', 'curriculum', 'period', 'level', 'icon', 'is_idp_eligible'];
    }
    move(payload) {
        this.$endpoint = '/subjects/move-subjects';
        return this.create(payload);
    }
    user(userId) {
        this.$endpoint = `groups/${userId}/subjects`;
        return this;
    }
    summary(filterStatuses) {
        const payload = {};
        if (this.$includes.length) {
            payload.with = this.$includes;
        }
        const keys = Object.keys(this.filters);
        if (keys.length) {
            keys.forEach((key) => {
                const model = this.filters[key];
                if (isObject(model) && typeof model.resolvePrimaryKey === 'function') {
                    this.filters[key] = model.resolvePrimaryKey();
                }
            });
            payload.filters = this.filters;
        }
        payload.filters.statuses = filterStatuses
            ? filterStatuses
            : [
                UserSubjectStatusEnum.BUSY,
                UserSubjectStatusEnum.HIGHLIGHTED,
                UserSubjectStatusEnum.OLD,
                UserSubjectStatusEnum.FINISHED,
                UserSubjectStatusEnum.CLOSED,
            ];
        payload.with = ['parent', 'level', 'period'];
        return client('get', `${this.$endpoint}/summary`, payload);
    }
    get isArea() {
        return Number(this.depth) === SubjectDepthEnum.AREA;
    }
    get isTopic() {
        return Number(this.depth) === SubjectDepthEnum.TOPIC;
    }
    get isSubject() {
        return Number(this.depth) === SubjectDepthEnum.SUBJECT;
    }
}
export var SubjectDepthEnum;
(function (SubjectDepthEnum) {
    SubjectDepthEnum[SubjectDepthEnum["AREA"] = 0] = "AREA";
    SubjectDepthEnum[SubjectDepthEnum["TOPIC"] = 1] = "TOPIC";
    SubjectDepthEnum[SubjectDepthEnum["SUBJECT"] = 2] = "SUBJECT";
})(SubjectDepthEnum || (SubjectDepthEnum = {}));
